"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var antd_1 = require("antd");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importDefault(require("react"));
var RevDateTimeToTimeStampPicker = function RevDateTimeToTimeStampPicker(props) {
  var required = props.required,
    _onChange = props.onChange,
    value = props.value;
  return react_1.default.createElement(antd_1.Form.Item, {
    required: required
  }, react_1.default.createElement(antd_1.DatePicker, {
    showTime: {
      format: 'HH:mm:ss'
    },
    disabled: props.readonly,
    allowClear: false,
    defaultValue: value ? moment_1.default(value) : value,
    onChange: function onChange(_value, dateString) {
      return _onChange(new Date(dateString).getTime());
    }
  }));
};
exports.default = RevDateTimeToTimeStampPicker;